import { render, staticRenderFns } from "./addAuthDialog.vue?vue&type=template&id=b5a616f4&scoped=true"
import script from "./addAuthDialog.vue?vue&type=script&lang=js"
export * from "./addAuthDialog.vue?vue&type=script&lang=js"
import style0 from "./addAuthDialog.vue?vue&type=style&index=0&id=b5a616f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a616f4",
  null
  
)

export default component.exports